import React, { useState } from 'react';
import { Box, Typography, Snackbar, Alert } from '@mui/material';
import { PersonAddOutlined } from '@mui/icons-material';
import { OnboardingForm } from './components/OnboardingForm';

const OnboardTenantTab = ({ apiKey }) => {
  const [snackNotification, setSnackNotification] = useState({
    open: false,
    severity: 'error',
    message: '',
  });

  return (
    <>
      <Box
        sx={{
          maxWidth: 1400,
          mx: "auto",
          px: { xs: 1, md: 2 },
          py: { xs: 1, md: 2 },
        }}
      >
        <Box
          sx={{
            borderRadius: { xs: 4, md: 6 },
            background: "radial-gradient(circle at top center, rgba(255, 191, 154, 0.28), rgba(255,255,255,0.94) 42%), linear-gradient(180deg, rgba(255, 248, 243, 0.96), rgba(255, 255, 255, 0.92))",
            boxShadow: "0 24px 60px rgba(236, 123, 55, 0.10)",
            border: "1px solid rgba(255, 132, 76, 0.10)",
            p: { xs: 2, md: 4 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 2.25,
              mb: 3.5,
            }}
          >
            <Box
              sx={{
                width: { xs: 56, md: 64 },
                height: { xs: 56, md: 64 },
                borderRadius: "20px",
                background: "linear-gradient(180deg, #ffb58d 0%, #ff8b47 100%)",
                boxShadow: "0 18px 38px rgba(255, 139, 71, 0.30)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                flexShrink: 0,
              }}
            >
              <PersonAddOutlined sx={{ fontSize: 30 }} />
            </Box>
            <Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: "2rem", md: "2.55rem" },
                  lineHeight: 1.05,
                  fontWeight: 800,
                  color: "#202531",
                  letterSpacing: "-0.03em",
                  mb: 0.8,
                }}
              >
                Onboard Tenant
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#6b7280",
                  fontWeight: 500,
                }}
              >
                Create a tenant and configure its onboarding details in one place.
              </Typography>
            </Box>
          </Box>

          <Box sx={{ maxWidth: 1100, mx: "auto", width: "100%" }}>
            <OnboardingForm
              apiKey={apiKey}
              setSnackNotification={setSnackNotification}
            />
          </Box>
        </Box>
      </Box>
      <Snackbar
        open={snackNotification.open}
        autoHideDuration={6000}
        onClose={() =>
          setSnackNotification((prevState) => ({
            ...prevState,
            open: false,
          }))
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() =>
            setSnackNotification((prevState) => ({
              ...prevState,
              open: false,
            }))
          }
          severity={snackNotification.severity}
          sx={{ width: '100%' }}
        >
          {snackNotification.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default OnboardTenantTab;
